import { render, staticRenderFns } from "./LowHandle.vue?vue&type=template&id=f2a828e4&"
import script from "./LowHandle.vue?vue&type=script&lang=js&"
export * from "./LowHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports